"use client";

import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Dashboard from "../components/dashboard/Dashboard";
import MeetingsDefaultRecent from "./MeetingsDefaultRecent";
import MeetingDetailsPage from "../components/meeting/MeetingDetailsPage";
import SalesTeamPage from "./SalesTeamPage";
import SalesExecutiveProfilePage from "./SalesExecutiveProfilePage";
import ClientsPage from "./ClientsPage";
import ClientProfilePage from "./ClientProfilePage";
import ClientDetailsPage from "./ClientDetailsPage";
import ClientInfoPage from "./ClientInfoPage";
import { MeetingProvider } from "../components/meeting/MeetingContext";

interface DashboardLayoutProps {
  onLogout: () => void;
  onLogoutAll:()=>void;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ onLogout,onLogoutAll }) => {
  const location = useLocation();
  const isRootPath = location.pathname === "/" || location.pathname === "/dashboard";

  return (
    <Flex w="full" h="100vh" overflow="hidden">
      <Box as="aside" h="100vh" flexShrink={0}>
        <Sidebar onLogout={onLogout} onLogoutAll={onLogoutAll} />
      </Box>
      <Box
        as="main"
        flex="1"
        p={8}
        bg="gray.50"
        overflowY="auto"
        h="100vh"
        position="relative"
      >
        <MeetingProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/meetings" element={<MeetingsDefaultRecent />} />
            <Route path="/meeting-details/:meetingId" element={<MeetingDetailsPage />} />
            <Route path="/sales-team" element={<SalesTeamPage />} />
            <Route path="/sales-executive/:id" element={<SalesExecutiveProfilePage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/client-info/:id" element={<ClientInfoPage />} />
            <Route path="/client-details/:id" element={<ClientDetailsPage />} />
            <Route path="/client-profile/:id" element={<ClientProfilePage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </MeetingProvider>
      </Box>
    </Flex>
  );
};

export default DashboardLayout;
